import classNames from 'classnames';
import { useState } from 'react';

import styles from './RestaurantHeader.module.scss';

import type { RestaurantModel } from '@/entities/restaurant/model/RestaurantModel';
import { useWorkTime } from '@/features/restaurants/lib/useWorkTime';
import { imageLink } from '@/shared/lib';
import { Rating } from '@/shared/ui-kit/Rating/Rating';

interface RestaurantHeaderProps {
  restaurant: RestaurantModel;
}

export const RestaurantHeader = ({ restaurant }: RestaurantHeaderProps) => {
  const { name, address, image } = restaurant;
  const [imageError, setImageError] = useState(false);

  const schedule = useWorkTime();

  return (
    <div className={styles.container}>
      {!imageError && image && (
        <div className={styles.image}>
          <img
            src={imageLink(image)}
            alt={name}
            onError={() => setImageError(true)}
          />
        </div>
      )}

      <div className={styles.details}>
        <h1 className={styles.title}>{name}</h1>
        <div className={styles.rating}>
          <Rating title="Кофейня" rating={restaurant.rating ?? '5.0'} />
          {schedule && (
            <h2
              className={classNames(styles.workingTime, {
                [styles.red]: schedule.style === 'red',
              })}
            >
              {schedule.text}
            </h2>
          )}
        </div>
      </div>

      <h2 className={styles.address}>{address}</h2>
    </div>
  );
};
